import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cost-performance-tab',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cost-performance-tab.component.html',
  styleUrls: ['./cost-performance-tab.component.scss'],
})
export class CostPerformanceTabComponent implements OnInit, OnChanges {
  @Input() isMultiWellMode = false;
  @Input() COST_DATA: any = { plannedAFE: 0, variance: 0, breakdown: [{}, { actual: 0 }] };
  @Input() PHASE_WISE: any[] = [];
  @Input() multiWellPhaseGrouped: any[] = [];
  @Input() multiWellTotalPlannedAFE = 0;
  @Input() multiWellTotalActualCost = 0;
  @Input() multiWellTotalVariance = 0;
  @Input() multiWellTotalNptHrs = 0;
  @Input() multiWellTotalHrs = 0;
  @Input() multiWellTotalNptCost = 0;
  @Input() singleWellTotalNptCost = 0;
  @Input() OVERVIEW_NPT_TOTAL_HRS: any = 0;
  @Input() OVERVIEW_NPT_PCT: any = 0;
  @Input() multiWellCostSummary: any[] = [];

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  fmtK(n: number): string {
    const isNegative = n < 0;
    const formatted = '$' + Math.abs(n / 1000).toFixed(2).replace(/\.00$/, '') + 'K';
    return isNegative ? '-' + formatted : formatted;
  }

  abs(n: number): number {
    return Math.abs(n);
  }

  variancePct(): number {
    const planned = this.isMultiWellMode
      ? Number(this.multiWellTotalPlannedAFE || 0)
      : Number(this.COST_DATA?.plannedAFE || 0);

    const actual = this.isMultiWellMode
      ? Number(this.multiWellTotalActualCost || 0)
      : Number(this.COST_DATA?.breakdown?.[1]?.actual || 0);

    if (!planned) return 0;
    return ((actual - planned) / planned) * 100;
  }

  nptCostValue(): number {
    return this.isMultiWellMode
      ? Number(this.multiWellTotalNptCost || 0)
      : Number(this.singleWellTotalNptCost || 0);
  }

  nptActualSpend(): number {
    return this.isMultiWellMode
      ? Number(this.multiWellTotalActualCost || 0)
      : Number(this.COST_DATA?.breakdown?.[1]?.actual || 0);
  }

  nptCostPctValue(): number {
    const spend = this.nptActualSpend();
    if (!spend) return 0;
    return (this.nptCostValue() / spend) * 100;
  }

  nptTotalCost(): number {
    return 0; // Overridden by parent via Input or parent method reference
  }
}
